import React from 'react';
import { useIntl } from 'react-intl';

import ForgotPasswordForm from '@/components/ForgotPasswordForm/ForgotPasswordForm';
import Grid from '@/components/Grid/Grid';
import PageNext from '@/components/Page/PageNext';
import { NextPage } from '@/pages/_app';

const PasswordRecoveryPage: NextPage = () => {
  const intl = useIntl();
  return (
    <PageNext title={intl.formatMessage({ id: 'app.auth.resetpassword' })}>
      <div className="geecko-authform-container">
        <Grid container fullHeight alignContent="center" alignItems="center" justify="center">
          <Grid item xs={12}>
            <div style={{ maxWidth: 532, padding: 16, margin: '0 auto' }}>
              <ForgotPasswordForm />
            </div>
          </Grid>
        </Grid>
      </div>
    </PageNext>
  );
};

PasswordRecoveryPage.accessGroups = 'public';

export default PasswordRecoveryPage;
